// @owners { team: patients-team }
import { type Brand } from '@alto/design-system';

type Images = typeof import('./index').images;

export async function loadImages(brand: Brand): Promise<Images> {
  switch (brand) {
    case 'fuzehealth':
      // webpack: /* webpackChunkName: "images-fuzehealth" */
      return (await import('./fuzehealth')).images;
    case 'alto':
    default:
      // webpack: /* webpackChunkName: "images-alto" */
      return (await import('./index')).images;
  }
}

let IMAGES = {} as Images | Record<string, never>;
export const setImages = (images: Images) => {
  IMAGES = images;
};

export const getImage = (imageName: keyof Images) => {
  return IMAGES[imageName];
};
